"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function customizable(componentName) {
    return function customizableFactory(ComposedComponent) {
        return _a = (function (_super) {
                __extends(ComponentWithInjectedProps, _super);
                function ComponentWithInjectedProps() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ComponentWithInjectedProps.prototype.render = function () {
                    var defaultProps = ((this.context.injectedProps) ?
                        this.context.injectedProps[componentName] :
                        null) || {};
                    return (React.createElement(ComposedComponent, __assign({}, defaultProps, this.props)));
                };
                return ComponentWithInjectedProps;
            }(React.Component)),
            _a.contextTypes = {
                injectedProps: React.PropTypes.object
            },
            _a;
        var _a;
    };
}
exports.customizable = customizable;

//# sourceMappingURL=customizable.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib/customizable.js
// module id = 147
// module chunks = 0